export default __webpack_public_path__ + "media/zurb/img/events/wired/dst/dst-thumb-cbed7034f1e88151dbbbd13071c47f71.png";